var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 53,
    viewBox: "0 0 145 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144.997,
    height: 52.726,
    rx: 8.4599,
    fill: "#090909"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_32270_134098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1231 13.3524C13.8174 13.6772 13.6367 14.1812 13.6367 14.834V38.1557C13.6367 38.8096 13.8174 39.3126 14.1231 39.6374L14.2008 39.7133L27.2145 26.6488V26.4949V26.3409L14.2008 13.2754L14.1231 13.3524Z",
    fill: "url(#paint0_linear_32270_134098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5559 31.0037L27.2187 26.6475V26.4935V26.3395L31.557 21.9844L31.6547 22.0403L36.7944 24.9718C38.2618 25.8091 38.2618 27.1789 36.7944 28.0173L31.6547 30.9489L31.5559 31.0037Z",
    fill: "url(#paint1_linear_32270_134098)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_32270_134098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6562 30.9465L27.2192 26.4922L14.1289 39.6347C14.6121 40.1493 15.4115 40.2126 16.3117 39.7001L31.6562 30.9465Z",
    fill: "url(#paint2_linear_32270_134098)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.6562 22.0395L16.3117 13.287C15.4115 12.7735 14.6121 12.8378 14.1289 13.3524L27.2203 26.4949L31.6562 22.0395Z",
    fill: "url(#paint3_linear_32270_134098)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8953 27.7699C68.5619 27.7699 66.66 29.5438 66.66 31.9871C66.66 34.4155 68.5619 36.2043 70.8953 36.2043C73.2296 36.2043 75.1315 34.4155 75.1315 31.9871C75.1305 29.5438 73.2286 27.7699 70.8953 27.7699ZM70.8953 34.5444C69.6164 34.5444 68.5142 33.4903 68.5142 31.9881C68.5142 30.47 69.6174 29.4318 70.8953 29.4318C72.1741 29.4318 73.2763 30.47 73.2763 31.9881C73.2763 33.4894 72.1741 34.5444 70.8953 34.5444ZM61.6549 27.7699C59.3216 27.7699 57.4197 29.5438 57.4197 31.9871C57.4197 34.4155 59.3216 36.2043 61.6549 36.2043C63.9893 36.2043 65.8912 34.4155 65.8912 31.9871C65.8912 29.5438 63.9893 27.7699 61.6549 27.7699ZM61.6549 34.5444C60.3761 34.5444 59.2739 33.4903 59.2739 31.9881C59.2739 30.47 60.3771 29.4318 61.6549 29.4318C62.9337 29.4318 64.036 30.47 64.036 31.9881C64.0369 33.4894 62.9337 34.5444 61.6549 34.5444ZM50.6646 29.0649V30.8537H54.9484C54.8205 31.8602 54.4851 32.5949 53.9732 33.1056C53.3502 33.7283 52.375 34.4155 50.6646 34.4155C48.0276 34.4155 45.9661 32.2905 45.9661 29.6549C45.9661 27.0193 48.0276 24.8943 50.6646 24.8943C52.0872 24.8943 53.126 25.4535 53.8929 26.1724L55.1558 24.9102C54.0843 23.8878 52.6627 23.1055 50.6646 23.1055C47.0524 23.1055 44.0156 26.0445 44.0156 29.6549C44.0156 33.2653 47.0524 36.2043 50.6646 36.2043C52.614 36.2043 54.0853 35.5647 55.2351 34.3669C56.4177 33.1849 56.7858 31.523 56.7858 30.1814C56.7858 29.7669 56.754 29.3832 56.6895 29.0639L50.6646 29.0649ZM95.6141 30.4541C95.2629 29.5121 94.1915 27.7699 92.0019 27.7699C89.8283 27.7699 88.0217 29.4794 88.0217 31.9871C88.0217 34.351 89.8124 36.2043 92.2093 36.2043C94.1428 36.2043 95.2619 35.0223 95.7262 34.3352L94.2877 33.3763C93.8085 34.0793 93.1527 34.5424 92.2093 34.5424C91.2668 34.5424 90.5951 34.1111 90.1636 33.2643L95.8056 30.9321L95.6141 30.4541ZM89.86 31.8602C89.8124 30.23 91.1229 29.4001 92.0664 29.4001C92.8015 29.4001 93.4246 29.7679 93.6329 30.2945L89.86 31.8602ZM85.2736 35.9495H87.1268V23.5537H85.2736V35.9495ZM82.2358 28.7129H82.1723C81.7566 28.2171 80.957 27.7699 79.951 27.7699C77.8409 27.7699 75.9073 29.6232 75.9073 32.004C75.9073 34.3679 77.8409 36.2053 79.951 36.2053C80.958 36.2053 81.7566 35.7581 82.1723 35.2474H82.2358V35.8543C82.2358 37.4676 81.3727 38.3303 79.9828 38.3303C78.8478 38.3303 78.1444 37.5162 77.8567 36.829L76.2426 37.5003C76.7059 38.6178 77.9361 39.9922 79.9828 39.9922C82.1564 39.9922 83.9948 38.714 83.9948 35.5985V28.0267H82.2368L82.2358 28.7129ZM80.1108 34.5444C78.832 34.5444 77.7615 33.4735 77.7615 32.004C77.7615 30.5176 78.832 29.4318 80.1108 29.4318C81.3727 29.4318 82.3638 30.5176 82.3638 32.004C82.3638 33.4735 81.3727 34.5444 80.1108 34.5444ZM104.299 23.5537H99.8632V35.9495H101.713V31.2533H104.298C106.349 31.2533 108.367 29.7689 108.367 27.404C108.367 25.0391 106.35 23.5537 104.299 23.5537ZM104.346 29.528H101.713V25.279H104.346C105.73 25.279 106.516 26.4243 106.516 27.404C106.516 28.3638 105.73 29.528 104.346 29.528ZM115.787 27.7481C114.447 27.7481 113.059 28.3381 112.485 29.646L114.127 30.3312C114.479 29.646 115.133 29.4219 115.819 29.4219C116.776 29.4219 117.75 29.996 117.765 31.0163V31.1443C117.43 30.9529 116.712 30.6663 115.835 30.6663C114.064 30.6663 112.26 31.6391 112.26 33.4566C112.26 35.1156 113.713 36.1835 115.34 36.1835C116.584 36.1835 117.27 35.6252 117.701 34.9708H117.764V35.9277H119.552V31.175C119.553 28.9757 117.908 27.7481 115.787 27.7481ZM115.563 34.5414C114.958 34.5414 114.112 34.238 114.112 33.4884C114.112 32.5315 115.165 32.1646 116.075 32.1646C116.887 32.1646 117.271 32.3401 117.765 32.5791C117.622 33.7283 116.632 34.5414 115.563 34.5414ZM126.062 28.0188L123.94 33.3932H123.877L121.674 28.0188H119.68L122.983 35.53L121.1 39.7086H123.03L128.121 28.0188H126.062ZM109.389 35.9495H111.239V23.5537H109.389V35.9495Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4345 16.2215C50.4345 17.0374 50.1887 17.6868 49.696 18.1716C49.137 18.748 48.4075 19.0362 47.5114 19.0362C46.6531 19.0362 45.9226 18.7441 45.3229 18.1599C44.7222 17.5748 44.4219 16.8504 44.4219 15.9858C44.4219 15.1203 44.7222 14.3959 45.3229 13.8118C45.9226 13.2266 46.6531 12.9345 47.5114 12.9345C47.9377 12.9345 48.345 13.0163 48.7316 13.1789C49.1192 13.3425 49.4294 13.5596 49.6614 13.8312L49.139 14.3453C48.7455 13.8828 48.2033 13.6521 47.5104 13.6521C46.884 13.6521 46.3428 13.8682 45.8859 14.3005C45.4289 14.7328 45.201 15.2946 45.201 15.9849C45.201 16.6752 45.4289 17.2369 45.8859 17.6692C46.3428 18.1015 46.884 18.3177 47.5104 18.3177C48.1746 18.3177 48.7286 18.1005 49.1717 17.6653C49.4591 17.382 49.6257 16.9877 49.6703 16.4824H47.5104V15.7804H50.3919C50.4216 15.9333 50.4345 16.0803 50.4345 16.2215Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.004 13.7816H52.2961V15.6334H54.7384V16.3354H52.2961V18.1873H55.004V18.9058H51.5318V13.0641H55.004V13.7816Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2263 18.9058H57.4621V13.7816H55.8008V13.0641H59.8875V13.7816H58.2263V18.9058Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8442 18.9058V13.0641H63.6085V18.9058H62.8442Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9975 18.9058H66.2333V13.7816H64.5721V13.0641H68.6588V13.7816H66.9975V18.9058Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3949 18.1512C75.8101 18.7412 75.0835 19.0362 74.2142 19.0362C73.3449 19.0362 72.6184 18.7412 72.0346 18.1512C71.4498 17.5612 71.1584 16.8388 71.1584 15.9849C71.1584 15.1311 71.4498 14.4086 72.0346 13.8186C72.6184 13.2286 73.3449 12.9326 74.2142 12.9326C75.0785 12.9326 75.8041 13.2296 76.3909 13.8225C76.9777 14.4154 77.2711 15.1359 77.2711 15.9849C77.2711 16.8388 76.9787 17.5612 76.3949 18.1512ZM72.5986 17.6615C73.0387 18.0996 73.5769 18.3177 74.2142 18.3177C74.8516 18.3177 75.3908 18.0986 75.8299 17.6615C76.27 17.2234 76.491 16.6645 76.491 15.9849C76.491 15.3053 76.27 14.7465 75.8299 14.3083C75.3908 13.8702 74.8516 13.6521 74.2142 13.6521C73.5769 13.6521 73.0387 13.8712 72.5986 14.3083C72.1595 14.7465 71.9384 15.3053 71.9384 15.9849C71.9384 16.6645 72.1595 17.2234 72.5986 17.6615Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3436 18.9058V13.0641H79.2733L82.1637 17.608H82.1964L82.1637 16.4824V13.0641H82.9279V18.9058H82.13L79.1058 14.1409H79.0731L79.1058 15.2664V18.9058H78.3436Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4345 16.2215C50.4345 17.0374 50.1887 17.6868 49.696 18.1716C49.137 18.748 48.4075 19.0362 47.5114 19.0362C46.6531 19.0362 45.9226 18.7441 45.3229 18.1599C44.7222 17.5748 44.4219 16.8504 44.4219 15.9858C44.4219 15.1203 44.7222 14.3959 45.3229 13.8118C45.9226 13.2266 46.6531 12.9345 47.5114 12.9345C47.9377 12.9345 48.345 13.0163 48.7316 13.1789C49.1192 13.3425 49.4294 13.5596 49.6614 13.8312L49.139 14.3453C48.7455 13.8828 48.2033 13.6521 47.5104 13.6521C46.884 13.6521 46.3428 13.8682 45.8859 14.3005C45.4289 14.7328 45.201 15.2946 45.201 15.9849C45.201 16.6752 45.4289 17.2369 45.8859 17.6692C46.3428 18.1015 46.884 18.3177 47.5104 18.3177C48.1746 18.3177 48.7286 18.1005 49.1717 17.6653C49.4591 17.382 49.6257 16.9877 49.6703 16.4824H47.5104V15.7804H50.3919C50.4216 15.9333 50.4345 16.0803 50.4345 16.2215Z",
    stroke: "white",
    strokeWidth: 0.0432537,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.004 13.7816H52.2961V15.6334H54.7384V16.3354H52.2961V18.1873H55.004V18.9058H51.5318V13.0641H55.004V13.7816Z",
    stroke: "white",
    strokeWidth: 0.0432537,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2263 18.9058H57.4621V13.7816H55.8008V13.0641H59.8875V13.7816H58.2263V18.9058Z",
    stroke: "white",
    strokeWidth: 0.0432537,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8442 18.9058V13.0641H63.6085V18.9058H62.8442Z",
    stroke: "white",
    strokeWidth: 0.0432537,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9975 18.9058H66.2333V13.7816H64.5721V13.0641H68.6588V13.7816H66.9975V18.9058Z",
    stroke: "white",
    strokeWidth: 0.0432537,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3949 18.1512C75.8101 18.7412 75.0835 19.0362 74.2142 19.0362C73.3449 19.0362 72.6184 18.7412 72.0346 18.1512C71.4498 17.5612 71.1584 16.8388 71.1584 15.9849C71.1584 15.1311 71.4498 14.4086 72.0346 13.8186C72.6184 13.2286 73.3449 12.9326 74.2142 12.9326C75.0785 12.9326 75.8041 13.2296 76.3909 13.8225C76.9777 14.4154 77.2711 15.1359 77.2711 15.9849C77.2711 16.8388 76.9787 17.5612 76.3949 18.1512ZM72.5986 17.6615C73.0387 18.0996 73.5769 18.3177 74.2142 18.3177C74.8516 18.3177 75.3908 18.0986 75.8299 17.6615C76.27 17.2234 76.491 16.6645 76.491 15.9849C76.491 15.3053 76.27 14.7465 75.8299 14.3083C75.3908 13.8702 74.8516 13.6521 74.2142 13.6521C73.5769 13.6521 73.0387 13.8712 72.5986 14.3083C72.1595 14.7465 71.9384 15.3053 71.9384 15.9849C71.9384 16.6645 72.1595 17.2234 72.5986 17.6615Z",
    stroke: "white",
    strokeWidth: 0.0432537,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3436 18.9058V13.0641H79.2733L82.1637 17.608H82.1964L82.1637 16.4824V13.0641H82.9279V18.9058H82.13L79.1058 14.1409H79.0731L79.1058 15.2664V18.9058H78.3436Z",
    stroke: "white",
    strokeWidth: 0.0432537,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_32270_134098",
    x: 13.6367,
    y: 12.9326,
    width: 24.2578,
    height: 27.1211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.168141
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32270_134098"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.168141
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_32270_134098",
    result: "effect2_innerShadow_32270_134098"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_32270_134098",
    x: 14.1289,
    y: 26.4922,
    width: 17.5273,
    height: 13.5615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.168141
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32270_134098"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32270_134098",
    x1: 26.0609,
    y1: 14.5872,
    x2: 8.36405,
    y2: 32.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32270_134098",
    x1: 38.7046,
    y1: 26.4935,
    x2: 13.2887,
    y2: 26.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32270_134098",
    x1: 29.2467,
    y1: 28.9112,
    x2: 5.24754,
    y2: 52.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32270_134098",
    x1: 10.8321,
    y1: 5.58881,
    x2: 21.5483,
    y2: 16.2634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.9406057d077e3fa9f90383bc1f106281.svg";
export { ForwardRef as ReactComponent };